var render = function render(){var _vm=this,_c=_vm._self._c;return _c('document-link',{staticClass:"pretty-waypoint-link has-hover-background",attrs:{"document":_vm.waypoint}},[_c('pretty-waypoint',{attrs:{"waypoint":_vm.waypoint}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }